import Flex from '@deprecated-ui/common/Flex';
import Modal from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const AuthModalContainer = styled(Modal)`
  .ant-modal-content {
    border-radius: 3px;
  }
`;

export const ProgressRejectedAuthModalContainer = styled(AuthModalContainer)`
  .ant-modal-body {
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const LoginTradingModalContainer = styled(AuthModalContainer)`
  .ant-modal-body {
    padding: 40px 40px 20px 40px;
  }

  /* Fade In & Scale Up Animation */
  @keyframes fadeScaleIn {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  /* Fade Out & Scale Down Animation */
  @keyframes fadeScaleOut {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0;
      transform: scale(0.8);
    }
  }

  /* Ant Design Modal Animation Overrides */
  .custom-modal-enter {
    animation: fadeScaleIn 0.5s ease-out;
  }

  .custom-modal-leave {
    animation: fadeScaleOut 0.5s ease-in;
  }
`;

export const CarouselContainer = styled(Flex)`
  width: 360px;
  min-height: 492px;
  background-color: #5dcbad26;
`;

export const RegisterInfoContainer = styled.div`
  width: 391px;
  padding: 40px 32px;
`;

export const RegisterInfoDivider = styled.div`
  width: 1px;
  height: 144px;
  background-color: ${color.downgray};
`;

export const LoginInfoDivider = styled.div`
  width: 185px;
  height: 1px;
  background-color: ${color.downgray};
`;

export const ButtonSubmit = styled.button`
  width: 160px;
  height: 40px;
  gap: 10px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-left: 20px;
  border-radius: 4px;
  background: #00AB6B;
  border: none;
  color: #FFF;
  font-family: var(--font-bold);
  cursor: pointer;

  :disabled {
    background: #CCEEE1;
    cursor: not-allowed;
  }
`;
